import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  connect() {
    this.element.style.opacity = "0";
    this.element.style.transform = "translateY(12px)";
    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        this.element.style.opacity = "1";
        this.element.style.transform = "translateY(0)";
      });
    });

    if (this.data.has("autoClose")) {
      setTimeout(() => this.close(), parseInt(this.data.get("autoClose")));
    }
  }

  close() {
    if (!this.element) return;
    this.element.style.opacity = "0";
    this.element.style.transform = "translateY(12px)";
    setTimeout(() => this.element?.remove(), 500);
  }
}
